// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsVerificationStatusesAddTemplate_heading__R9+l9","buttonLink":"ReportingDetailsVerificationStatusesAddTemplate_buttonLink__ct5fI"};